import { transform } from './transform';

/**
 * Compute media type position assertion object based on current media type.
 * @arg {currentMediaType} breakpoints - The curent media type.
 * @arg {object} breakpointOrder - The order of breakpoints.
 * @arg {string} assertion [greaterThan, lessThan];
 * @returns {object} The `lessThan` object.  Its keys are the same as the
 * keys of the breakpoints object.  The value for each key indicates whether
 * or not the browser width is less than the breakpoint.
 */
export function assertMediaTypePosition(currentMediaType, breakpointOrder, assertion) {
  // get the ordering of the current media type
  var currentOrder = breakpointOrder[currentMediaType];
  return transform(breakpointOrder, function (result, breakpoint, mediaType) {
    // if the breakpoint is a number
    if (typeof breakpoint === 'number') {
      switch (assertion) {
        case 'greaterThan':
          result[mediaType] = currentOrder > breakpointOrder[mediaType];
          break;
        case 'lessThan':
          result[mediaType] = currentOrder < breakpointOrder[mediaType];
          break;
        default:
      }
      // handle non numerical breakpoints specially
    } else {
      result[mediaType] = false;
    }
  });
}